export default defineNuxtPlugin(nuxtApp => {
  // TODO check if we can use the feature flag in posthog
  const config = useRuntimeConfig()

  const isAlpha = config.public.name === 'alpha'
  const isBeta = config.public.name === 'beta'
  const isApp = config.public.name === 'app'

  const features = {
    tableAdvancedSetting: isAlpha || isBeta, 
    scrollable: isAlpha,
    learn: isAlpha || isBeta,
    qc: isBeta || isApp,
    trainingRuns: isAlpha,
    comments: isAlpha || isBeta,
    posthogTesting: isAlpha,
    showDocStatus: isAlpha || isBeta,
    showDocStatusInTable: isAlpha,
    dan: isAlpha || isBeta,
    hermesTest: isAlpha || isBeta,
    notifications: isAlpha || isBeta,
    cancelSubscriptions: isAlpha || isBeta,
    dataSets: isAlpha,
    siteAnalytics: isAlpha || isBeta,
    tableUX: isAlpha || isBeta,
    newSidebar: isAlpha || isBeta,
    pageTranslate: isAlpha,
    batchSummarize: isAlpha,
    structureTagAttributes: isAlpha || isBeta || isApp,
    uploadSortModal: isAlpha || isBeta || isApp,
    highlightSearchTerms: isAlpha || isBeta || isApp,
    sitesFilterMultiSelect: isAlpha || isBeta || isApp,
    sitesSearchMode: isAlpha || isBeta || isApp,
    labelsForModels: isAlpha,
    structureTable: isAlpha,
    sitesWorldMap: isAlpha || isBeta || isApp,
    debug: isAlpha,
    projects: isAlpha,
    advancedRegionSort: isAlpha || isBeta || isApp,
    findDocumentsBySearchRequest: isAlpha || isBeta,
    collectionActivityChart: isAlpha,
    docLoadingSkeleton: isAlpha || isBeta || isApp,
    richCollectionDesc: isAlpha || isBeta || isApp,
    collectionColor: isAlpha || isBeta,
    e2eModelsEditor: isAlpha,
  }
  return {
    provide: {
      features,
    },
  }
})
